import React from "react";
import { Modal, Button } from "react-bootstrap";
import { confirmable, createConfirmation } from "react-confirm";

class DisableModuleConfirm extends React.Component {
    render() {
        const { show, proceed } = this.props;

        return (
            <Modal
                show={show}
                onHide={() => proceed(false)}
                backdrop="static"
                keyboard={true}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Disable Module</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        You're about to disable the selected modules for this
                        brand/dashboard.
                    </p>
                    <p>
                        Would you also like to unassign this module from all
                        products for this brand? (This action cannot be undone
                        automatically)
                    </p>
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", flexWrap: "nowrap" }}>
                    <Button
                        variant="primary"
                        onClick={() => proceed("disable_unassign")}
                        data-testid="disable-unassign"
                        style={{ whiteSpace: "normal", flex: "1" }}
                    >
                        Disable & Unassign from All Products
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => proceed("disable_only")}
                        data-testid="disable-only"
                        style={{ whiteSpace: "normal", flex: "1" }}
                    >
                        Disable Module Only
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => proceed(false)}
                        data-testid="disable-cancel"
                        style={{ whiteSpace: "nowrap", flex: "0 0 auto" }}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default function confirm() {
    return createConfirmation(confirmable(DisableModuleConfirm))({});
}
